<template>
  <div v-if="haveVettingBookingRequest">
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>Duplicate Pending Request</h1>
      </div>
    </div>

    <booking-duplicate-form
      :booking="booking"
      :set-booking-action="setVettingBookingRequest"
      :set-booking-property-mutator="setVettingRequestProperty">
      <span slot="button">Submit Request</span>
    </booking-duplicate-form>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { helpers } from 'mixins/bookings'
import BookingDuplicateForm from 'components/booking/BookingDuplicateForm'

export default {
  props: ['id'],

  mixins: [helpers],

  components: {
    BookingDuplicateForm
  },

  computed: {
    ...mapState('booking/request/vetting', {
      booking: 'request'
    }),
    ...mapGetters('booking/request/vetting', ['haveVettingBookingRequest'])
  },

  created () {
    this.getVettingBookingRequest({ id: this.id })
      .catch((error) => {
        this.handleCaughtHttpExceptionForBooking(error, 'The vetting booking request could not be found.')
      })
  },

  methods: {
    ...mapActions('booking/request/vetting', [
      'getVettingBookingRequest',
      'setVettingBookingRequest',
      'setVettingRequestProperty'
    ])
  }
}
</script>
